<template>
    <div class="pantalla-menu">
        <div class="container-mob w-100 pb-0">

            <buscador-component></buscador-component>
            <div class="text-end mt-4">
                <a href="javascript: window.history.back()" class="color-red pe-3">
                    <i class="fas fa-chevron-left"></i>
                </a>
            </div>
            <div class="producto">
                <h3 class="mb-2">Favoritos</h3>

            </div>
            <div class="row" v-if="products.length > 0">
                <div class="col-6" v-for="(producto, key) in products">
                    <div class="series text-center position-relative py-2">

                        <div class="favorito-icon text-end" @click="favoritoToggle(producto)">
                            <i class="fa-heart" :class="producto.favorito ? 'fas' : 'far'"></i>
                        </div>
                        <router-link :to="{ name: 'producto', params: { slug: producto.slug } }">
                            <img :src="'/storage/'+producto.imagenes[0]" class="imagen-producto">
                            <p class="color-red mt-3 mb-0">{{ producto.nombre }}</p>
                        </router-link>
                    </div>
                </div>
            </div>

            <div v-else>
                <p>{{sin_favoritos}}</p>
            </div>
        </div>
        <menu-component></menu-component>
    </div>
</template>

<script>

export default {
    data() {
        return {
            products: [],
            sin_favoritos : '',
            errors: null
        };
    },
    methods: {
        favoritoToggle: function (producto) {
            this.$store
            .dispatch("favoritoToggle", {id: producto.id, value: !producto.favorito})
            .then(response => {
                producto.favorito = !producto.favorito
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        }
    },
    mounted: function () {
        this.$store
        .dispatch("getFavoritos", {})
        .then(response => {
            this.products = response.data;
            if(this.products.length === 0){
                this.sin_favoritos = 'Actualmente, no existe ninguna unidad en tu lista de favoritos. Añade aquellas unidades con las que más trabajes para tenerlas en esta lista.'
            }
        })
        .catch(error => {
            this.errors = error.response.data;
        });
    }
};
</script>
